import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'w-full'
})`
  .MuiAccordion-root {
    box-shadow: none;
    border-top: solid black 1px;
    border-bottom: solid #f3f4f3 1px;
    border-radius: 0 !important;
  }

  .Mui-expanded {
    margin: 8px 0px;
  }

  .MuiAccordionSummary-root {
    height: 0;
    padding: 0 25px;
  }
`;
